<mat-nav-list class="report-section-sidebar">
  <mat-list>
    <mat-list-item (click)="navigateToHome()" matTooltip="{{constants.LABELS.backToClientSelection}}"
      matTooltipPosition="right" matTooltipClass="bg-accent">
      <mat-icon matListIcon>home</mat-icon>
      <h3 matLine>{{constants.LABELS.backToClientSelection}}</h3>
    </mat-list-item>
  </mat-list>
  @if (mainMenu.length > 0) {
    <mat-divider></mat-divider>
  }
  @if (mainMenu.length > 0) {
    <div mat-subheader class="text-label">Reports</div>
  }
  @for (menu of mainMenu; track menu) {
    <mat-list [class.submenu]="menu.subReports.length > 0" [class.open]="showSubMenus && menu.reportId === reportId"
      (click)="clickMainMenu(menu)">
      <mat-list-item [class.selected]="menu.reportId === reportId && !(showDocuments || showInvoices)"
        matTooltip="{{menu.reportName}}" matTooltipPosition="right" matTooltipClass="bg-accent">
        <mat-icon matListIcon class="empirx-icon">{{menuIcons(menu.reportId)}}</mat-icon>
        <h3 matLine>{{menu.reportName}}</h3>
        @if (menu.subReports.length > 0) {
          <mat-icon class="down-arrow">expand_more</mat-icon>
        }
      </mat-list-item>
      @if (showSubMenus && reportId ===menu.reportId) {
        <mat-nav-list>
          @for (sb of subMenu; track sb) {
            <mat-list (click)="clickSubMenu(sb)">
              <mat-list-item [class.selected]="sb.reportId === subReportId && !(showDocuments || showInvoices)"
                matTooltip="{{sb.reportName}}" matTooltipPosition="right" matTooltipClass="bg-accent">
                <h3 matLine>{{sb.reportName}} </h3>
              </mat-list-item>
            </mat-list>
          }
        </mat-nav-list>
      }
    </mat-list>
  }
  @if (mainMenu.length > 0) {
    <mat-divider></mat-divider>
  }
  @if (mainMenu.length > 0) {
    <mat-list (click)="showOtherMenus()">
      <mat-list-item matTooltip="{{constants.LABELS.documents}}" [class.selected]="showDocuments"
        matTooltipPosition="right" matTooltipClass="bg-accent">
        <mat-icon matListIcon>description</mat-icon>
        <h3 matLine>{{constants.LABELS.documents}}</h3>
      </mat-list-item>
    </mat-list>
  }
  @if (isInvoice) {
    <mat-divider></mat-divider>
  }
  @if (isInvoice) {
    <mat-list (click)="clickedInvoices()">
      <mat-list-item matTooltip="{{constants.LABELS.financialDocuments}}" [class.selected]="showInvoices"
        matTooltipPosition="right" matTooltipClass="bg-accent">
        <mat-icon matListIcon class="empirx-icon">financialdocument</mat-icon>
        <h3 matLine>{{constants.LABELS.financialDocuments}}</h3>
      </mat-list-item>
    </mat-list>
  }
  <mat-divider></mat-divider>
  <mat-list (click)="showWhoWeArePage()">
    <mat-list-item matTooltip="{{constants.LABELS.whoWeAre}}" matTooltipPosition="right"
      matTooltipClass="bg-accent">
      <mat-icon matListIcon>groups</mat-icon>
      <h3 matLine>{{constants.LABELS.whoWeAre}}</h3>
    </mat-list-item>
  </mat-list>
</mat-nav-list>